// extracted by mini-css-extract-plugin
export default {"title":"Burn_title__F7nnE","text":"Burn_text__ZZQ7B","info":"Burn_info__35AiA","input":"Burn_input__7SBr+","btns":"Burn_btns__bpYUj","button":"Burn_button__bqISE"};